<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tab" @input="load">
          <b-tab v-for="item in $store.state.countries" :key="item._id" :title="item.name"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="search"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="gateway"
                         :options="gatewayOptions"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-md">{{ $t('info') }}</div>
            <div class="col-md text-center">{{ $t('invoiceQuantity') }}</div>
            <div class="col-md text-center">{{ $t('eSignPrice') }}</div>
            <div class="col-md text-center">{{ $t('invoicePrice') }}</div>
            <div class="col-md text-center">{{ $t('setupFee') }}</div>
            <div class="col-md">{{ $t('time') }}</div>
            <div class="col-md"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-md">
              <div>
                <b>{{ $t('name') }}: </b>
                <span v-if="item.name">{{ item.name }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('supplier') }}: </b>
                <span v-if="item.gateway">{{ item.gateway.name }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-md text-center">{{ (item.invoiceQuantity || 0) | numFormat }}</div>
            <div class="col-md text-center">{{ (item.esignPrice || 0) | numFormat }}</div>
            <div class="col-md text-center">{{ (item.invoicePrice || 0) | numFormat }}</div>
            <div class="col-md text-center">{{ (item.setupFee || 0) | numFormat }}</div>
            <div class="col-md">
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('updateTime') }}: </b>
                <span v-if="item.updateTime">{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-md text-right">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" size="lg" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <country-select :model="formModel" :errors="formErrors"></country-select>
      <form-select :full-width="true" :label="$t('supplier')" :model="formModel" attribute="gateway"
                   :options="gatewayOptions" :errors="formErrors"></form-select>
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <form-input :label="$t('invoiceQuantity')" :model="formModel" attribute="invoiceQuantity"
                  type="number" :errors="formErrors"></form-input>
      <form-input :label="$t('eSignPrice')" :model="formModel" attribute="esignPrice"
                  type="number" :errors="formErrors"></form-input>
      <form-input :label="$t('invoicePrice')" :model="formModel" attribute="invoicePrice"
                  type="number" :errors="formErrors"></form-input>
      <form-input :label="$t('setupFee')" :model="formModel" attribute="setupFee"
                  type="number" :errors="formErrors"></form-input>
      <form-input :label="$t('position')" :model="formModel" attribute="position"
                  type="number" :errors="formErrors"></form-input>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import CountrySelect from "@/components/CountrySelect.vue";

export default {
  components: {CountrySelect, TimeRangePicker},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/invoice-plan',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        gateway: null
      },
      defaultFormModel: {
        country: null,
        gateway: null,
        name: null,
        invoiceQuantity: 1,
        esignPrice: 0,
        invoicePrice: 0,
        setupFee: 0,
        position: 1
      },
      gatewayOptions: [],
      tab: 0
    }
  },
  i18n: {
    messages: {
      en: {
        eSignPrice: 'Digital signature price / year',
        invoicePrice: 'Invoice package price',
        supplier: 'Supplier',
        invoiceQuantity: 'Number of invoices in the package',
        chooseSupplier: 'Choose a supplier',
        position: 'Position',
        setupFee: 'Setup fee'
      },
      vi: {
        eSignPrice: 'Giá chữ ký số / năm',
        invoicePrice: 'Giá gói hóa đơn',
        supplier: 'Nhà cung cấp',
        invoiceQuantity: 'Số lượng hóa đơn trong gói',
        chooseSupplier: 'Chọn nhà cung cấp',
        position: 'Vị trí',
        setupFee: 'Phí khởi tạo'
      }
    }
  },
  methods: {
    search() {
      this.filterFormModel.page = 1;
      this.load()
    },
    load: function () {
      this.filterFormModel.country = this.getCountryId(this.tab);
      let loader = this.$loading.show();
      this.loading = true;
      this.listLoading = true;
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
        this.listLoading = false;
        if (this.afterLoad) {
          this.afterLoad();
        }
      });
    },
    getCountryId: function (index) {
      let country = this.$store.state.countries[index];
      return country ? country._id : null;
    },
    create: function () {
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      this.formModel.country = this.filterFormModel.country;
      this.formTitle = this.$t('create');
      this.formErrors = [];
      this.showForm = true;
    },
  },
  mounted() {
    this.gatewayOptions = [{value: null, text: this.$t('chooseSupplier')}]
    this.$service.get('/invoice-gateway', {
      params: {
        page: 1,
        pageSize: 100
      }
    }).then(response => {
      if (response && response.data) {
        response.data.docs.forEach(gateway => {
          this.gatewayOptions.push({value: gateway._id, text: `${gateway.name} (${gateway.code})`});
        })
      }
    })
  }
};
</script>